import UserProfileContainer from './UserProfileContainer';

export default UserProfileContainer;
